// src/components/Assessment/assessmentQuestions.js

export const assessmentQuestions = [
  {
    id: 'intro',
    type: 'intro',
    title: 'Find Your Perfect AI Learning Path',
    description: 'This 2-minute assessment analyzes your background, goals, and experience to recommend the ideal track for your AI journey. We\'ve helped over 1,000 students find their path.',
    purpose: 'Welcome user and set expectations for the assessment',
    nextButtonText: 'Start Assessment'
  },
  {
    id: 'skill',
    type: 'radio',
    title: 'How comfortable are you with coding and technical concepts?',
    description: 'This helps us understand your starting point and recommend the right pace.',
    purpose: 'Assess technical foundation and coding experience',
    field: 'skill',
    options: [
      { value: 'beginner', label: 'I have never coded or have very basic exposure' },
      { value: 'some', label: 'I know some basics but struggle to build things on my own' },
      { value: 'intermediate', label: 'I can build small applications and understand programming concepts' },
      { value: 'advanced', label: 'I regularly build projects and feel confident solving technical problems' }
    ]
  },
  {
    id: 'background',
    type: 'radio',
    title: 'What describes your current professional situation?',
    description: 'This helps us tailor the learning experience to your lifestyle and commitments.',
    purpose: 'Understand user context and availability constraints',
    field: 'background',
    options: [
      { value: 'student', label: 'Student / Recent graduate' },
      { value: 'switcher', label: 'Career switcher (from non-tech field)' },
      { value: 'working', label: 'Working professional (tech or non-tech)' }
    ]
  },
  {
    id: 'experience',
    type: 'radio',
    title: 'What\'s your experience with building projects?',
    description: 'Real project experience is the best indicator of readiness for advanced AI work.',
    purpose: 'Evaluate practical experience and project capability',
    field: 'experience',
    options: [
      { value: 'noProjects', label: 'I haven\'t built any complete projects yet' },
      { value: 'smallProjects', label: 'I\'ve built small projects (tutorials, college assignments)' },
      { value: 'hasProjects', label: 'I\'ve built real projects for work, freelance, or personal use' }
    ]
  },
  {
    id: 'confidence',
    type: 'slider',
    title: 'How confident do you feel about learning AI and machine learning?',
    description: 'Your confidence level helps us understand how much support and guidance you might need.',
    purpose: 'Measure self-efficacy and learning readiness',
    field: 'confidence',
    min: 0,
    max: 10,
    step: 1,
    defaultValue: 5,
    labels: {
      0: 'Not confident',
      5: 'Moderately confident', 
      10: 'Very confident'
    }
  },
  {
    id: 'timeAvailability',
    type: 'radio',
    title: 'How much time can you dedicate to learning AI daily?',
    description: 'Be realistic about your schedule - consistency matters more than intensity.',
    purpose: 'Determine time commitment and learning pace',
    field: 'timeAvailability',
    options: [
      { value: '1to2', label: '1-2 hours (part-time while working/studying)' },
      { value: '3to4', label: '3-4 hours (serious part-time commitment)' },
      { value: '5to6', label: '5-6 hours (full-time student level)' },
      { value: '10+', label: '10+ hours (full-time intensive learning)' }
    ]
  },
  {
    id: 'goal',
    type: 'radio',
    title: 'What\'s your primary goal for the next 6 months?',
    description: 'Your goal determines the focus and intensity of your learning path.',
    purpose: 'Align recommendation with user objectives and timeline',
    field: 'goal',
    options: [
      { value: 'getJob', label: 'Get a job or internship in AI/tech' },
      { value: 'switchCareer', label: 'Switch careers into AI development' },
      { value: 'growSkills', label: 'Grow my technical skills for current role' },
      { value: 'research', label: 'Prepare for research or advanced studies' }
    ]
  },
  {
    id: 'contact',
    type: 'contact',
    title: 'Where can we send your personalized learning plan?',
    description: 'We\'ll create a customized roadmap based on your assessment and send it directly to your inbox.',
    purpose: 'Collect contact information for follow-up and personalization',
    fields: [
      {
        id: 'name',
        type: 'text',
        placeholder: 'Your full name',
        required: true
      },
      {
        id: 'email', 
        type: 'email',
        placeholder: 'Your best email address',
        required: true
      }
    ]
  }
];

export const getQuestionByStep = (step) => assessmentQuestions[step];
export const getTotalSteps = () => assessmentQuestions.length;